import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=baa88044&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa88044')) {
      api.createRecord('baa88044', component.options)
    } else {
      api.reload('baa88044', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=baa88044&", function () {
      api.rerender('baa88044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Form.vue"
export default component.exports